import script from "./LowAttendance.vue?vue&type=script&setup=true&lang=ts"
export * from "./LowAttendance.vue?vue&type=script&setup=true&lang=ts"

import "./LowAttendance.vue?vue&type=style&index=0&id=6f02d444&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f02d444"]])

export default __exports__